import React from 'react';
import Select from 'react-select';
import TextInput from 'views/components/TextInput';
import { getTheme } from 'utils/SelectTheme';
import countryOptions from '../countryOptions';
import SelectStyles from '../SelectStyles';

const ContactForm = ({ formData, onChange }) => {
  const selectedCountry = countryOptions.find((option) => option.value === formData.contactCountry) || null;

  return (
    <div className="input-grid question-grid">
      <label>
        <p>Business Email Address</p>
        <TextInput
          className="lite-input"
          placeholder="your.email@company.com"
          type="email"
          value={formData.contactEmail}
          onValueChange={onChange('contactEmail')}
        />
      </label>
      <label>
        <p>First Name</p>
        <TextInput className="lite-input" placeholder="First name" value={formData.contactFirstName} onValueChange={onChange('contactFirstName')} />
      </label>
      <label>
        <p>Last Name</p>
        <TextInput className="lite-input" placeholder="Last name" value={formData.contactLastName || ''} onValueChange={onChange('contactLastName')} />
      </label>
      <label>
        <p>Job Title</p>
        <TextInput className="lite-input" placeholder="Job title" value={formData.contactJobTitle} onValueChange={onChange('contactJobTitle')} />
      </label>
      <label>
        <p>Company Name</p>
        <TextInput className="lite-input" placeholder="Your organization name" value={formData.contactCompany} onValueChange={onChange('contactCompany')} />
      </label>
      <label>
        <p>Country</p>
        <Select
          inputId="contact-country"
          data-testid="contact-country-select"
          placeholder="Select a country"
          options={countryOptions}
          value={selectedCountry}
          onChange={(option) => onChange('contactCountry')(option?.value || '')}
          theme={getTheme}
          menuPlacement="auto"
          styles={SelectStyles}
        />
      </label>
      <label>
        <p>
          Additional Comments <span className="optional-label">(optional)</span>
        </p>
        <textarea
          className="lite-input lite-textarea"
          placeholder="Any additional information you'd like to share"
          value={formData.contactComments || ''}
          onChange={(e) => onChange('contactComments')(e.target.value)}
          rows={4}
        />
      </label>
      <label className="consent-checkbox">
        <input type="checkbox" checked={!!formData.consent} onChange={(e) => onChange('consent')(e.target.checked)} required />
        <span>
          By submitting this form, I consent to Equinix &amp; its affiliates collecting and processing my personal data, and understand they may contact me to
          follow up on the report insights. For more information check out{' '}
          <a href="https://www.equinix.com/about/legal/privacy" target="_blank" rel="noopener noreferrer">
            Equinix Privacy Policy
          </a>
          .
        </span>
      </label>
    </div>
  );
};

export default ContactForm;
